import React from 'react';
import { PatientMiniCardComponent } from '../../../components/Cards';
import { usePatient } from '../../../contexts/patient';
import { useCristal } from '../../../contexts/cristal';
import { useOrganization } from '../../../contexts/organization';

const MiniProfile = () => {
  const { getOrganizationName } = useOrganization();
  const { getDisplayName, getDateOfBirth, getMrn } = usePatient();
  const { score } = useCristal();
  return (
    <PatientMiniCardComponent
      displayName={getDisplayName()}
      birthDate={getDateOfBirth()}
      mrn={getMrn()}
      score={score.toString()}
      organization={getOrganizationName()}
    />
  );
};
export default MiniProfile;
